import jQuery from 'jquery';
import { ajaxMarkup } from '../helpers/ajax';

const pageModificators = {
    'pro-card': '/pro/',
    'free-card': '/'
};

export default class DynamicRunners {
    constructor(config) {
        const defaultConfig = {
            runnersContainerSelector: '.js-RC-runnerRowWrapper',
            pageParametersSelector: '[data-page-type]',
            loaderElementSelector: '.js-RC-runnerLoader',
            loaderFloatingElementSelector: '.js-RC-runnerLoader_floating',
            errorElementSelector: '.js-RC-runnerError',
            errorFloatingElementSelector: '.js-RC-runnerError_floating',
            errorReloadElementSelector: '.js-RC-runnerFloater__reload',
            floatingClass: 'RC-runnerFloater_floating',
            visibleClass: 'RC-runnerFloater_visible',
            pageTypeAttrName: 'data-page-type',
            pageRaceIdAttrName: 'data-card-race-id',
            pagePagesNumberAttrName: 'data-runners-total-pages'
        };

        this.config = jQuery.extend(true, defaultConfig, config || {});
        this.getRunners = this.getRunners.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.onGetRunnersSuccess = this.onGetRunnersSuccess.bind(this);
        this.onGetRunnersError = this.onGetRunnersError.bind(this);
        this.onRunnersRequestFinished = this.onRunnersRequestFinished.bind(this);
        this.init();
    }

    get runnersContainer() {
        if (!this.$runnersContainer) {
            this.$runnersContainer = jQuery(this.config.runnersContainerSelector);
        }

        return this.$runnersContainer;
    }

    get loaderElement() {
        if (!this.$loaderElement) {
            this.$loaderElement = jQuery(this.config.loaderElementSelector);
        }

        return this.$loaderElement;
    }

    get loaderFloatElement() {
        if (!this.$loaderFloatElement) {
            this.$loaderFloatElement = jQuery(this.config.loaderFloatingElementSelector);
        }

        return this.$loaderFloatElement;
    }

    get errorElement() {
        if (!this.$errorElement) {
            this.$errorElement = jQuery(this.config.errorElementSelector);
        }

        return this.$errorElement;
    }

    get reloadElement() {
        if (!this.$errorReloadElementSelector) {
            this.$errorReloadElementSelector = jQuery(this.config.errorReloadElementSelector);
        }

        return this.$errorReloadElementSelector;
    }

    get errorFloatElement() {
        if (!this.$errorFloatElement) {
            this.$errorFloatElement = jQuery(this.config.errorFloatingElementSelector);
        }

        return this.$errorFloatElement;
    }

    init() {
        this.isFloat = false;
        this.isLoading = false;
        this.isError = true;
        this.currentRunnerPage = 0;
        this.definePageParameters();
        this.bindEvents();
    }

    bindEvents() {
        if (this.pageTypeModificator && this.raceId && this.pagesNumber) {
            jQuery(document).ready(this.getRunners);
        }
    }

    definePageParameters() {
        const $pageParametersElement = jQuery(this.config.pageParametersSelector);

        if ($pageParametersElement.length) {
            const modificator = $pageParametersElement.attr(this.config.pageTypeAttrName);

            this.pageTypeModificator = pageModificators[modificator];
            this.raceId = $pageParametersElement.attr(this.config.pageRaceIdAttrName);
            this.pagesNumber = +$pageParametersElement.attr(this.config.pagePagesNumberAttrName);
        }
    }

    onScroll() {
        const wrapper = this.runnersContainer[0];
        const windowHeight = window.innerHeight;
        const runnerWrappetBottom = wrapper.getBoundingClientRect().bottom;
        const positionInPercent = Math.floor((runnerWrappetBottom / windowHeight) * 100);
        this.isFloat = positionInPercent >= 100;
        this.updateView();
        if (positionInPercent <= 95) {
            this.getRunners();
        }
    }

    getRunners() {
        if (this.pagesNumber <= this.currentRunnerPage || this.isLoading) {
            return jQuery.Deferred().resolve().promise();
        }
        this.isError = false;
        this.isLoading = true;
        this.updateView();
        this.onScroll();
        return this.chainRequests()
            .fail(this.onGetRunnersError)
            .always(this.onRunnersRequestFinished);
    }

    chainRequests() {
        if (this.pagesNumber <= this.currentRunnerPage) {
            return jQuery.Deferred().resolve().promise();
        }
        return this.createDataRequest()
            .then(this.onGetRunnersSuccess)
            .then(() => (this.chainRequests()));
    }

    createDataRequest() {
        return ajaxMarkup({
            method: 'GET',
            url: this.getDataUrl(this.currentRunnerPage + 1)
        });
    }

    getDataUrl(pageNumber) {
        return `/racecards/data/runners${this.pageTypeModificator}${this.raceId}/${pageNumber}`;
    }

    onGetRunnersSuccess(data) {
        this.currentRunnerPage += 1;
        if (this.loaderElement.length) {
            this.loaderElement.before(data);
            this.onScroll();
        }
    }

    onGetRunnersError() {
        this.isError = true;
    }

    onRunnersRequestFinished() {
        this.isLoading = false;
        this.updateView();
        const document = window.document;
        jQuery(document).trigger('RC.priceUpdatedToSort');
        jQuery(document).trigger('dynamicPricesUpdated');
        if (this.currentRunnerPage >= this.pagesNumber) {
            this.loaderElement.remove();
            this.errorElement.remove();
        }
    }

    updateView() {
        if (this.isLoading || this.isError) {
            if (!this.scrollSubscribed) {
                this.scrollSubscribed = true;
                jQuery(window).on('scroll', this.onScroll);
            }
        } else {
            if (this.scrollSubscribed) {
                jQuery(window).off('scroll', this.onScroll);
            }
            this.scrollSubscribed = false;
        }

        if (this.isFloat) {
            this.loaderFloatElement.addClass(this.config.floatingClass);
            this.errorFloatElement.addClass(this.config.floatingClass);
        } else {
            this.loaderFloatElement.removeClass(this.config.floatingClass);
            this.errorFloatElement.removeClass(this.config.floatingClass);
        }

        if (this.isLoading) {
            this.loaderElement.addClass(this.config.visibleClass);
        } else {
            this.loaderElement.removeClass(this.config.visibleClass);
        }

        if (this.isError) {
            if (!this.reloadButtonSubscribed) {
                this.reloadButtonSubscribed = true;
                this.reloadElement.on('click', this.getRunners);
            }
            this.errorElement.addClass(this.config.visibleClass);
        } else {
            this.errorElement.removeClass(this.config.visibleClass);
        }
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/dynamicRunners.js